import { replaceByObject } from '@/common/utils/strings/replace.utils';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replace',
})
export class ReplacePipe implements PipeTransform {
    transform(value: string, toReplace: any): unknown {
        return replaceByObject(value, toReplace);
    }
}
